import { StyleSheet, Platform } from 'react-native'
import { Theme } from '@theme'

const AVATAR_SIZE = 50
const ITEM_HEIGHT = 70


export const getCommonContactsStyles = (theme: Theme) => StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: theme.colors.background,
    marginBottom: theme.spacing.xxxl,
    paddingHorizontal: theme.spacing.lg, // Replace margin with padding for inner elements
  },
  searchbarContainerNonMobile: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: theme.spacing.lg,
    backgroundColor: theme.colors.background,
  },
  searchbar: {
    flex: 1,
    backgroundColor: theme.colors.white,
    borderRadius: theme.border.jumbo,
    shadowColor: theme.colors.black,
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.05,
    shadowRadius: 2,
    elevation: 1,
    marginRight: theme.spacing.md,
  },
  searchbarMobile: {
    flex: undefined,
    marginLeft: theme.spacing.md,
    marginBottom: theme.spacing.md,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing.xxl,
    paddingBottom: theme.spacing.sm,
    marginTop: theme.spacing.xxxl
  },
  roundedIcon: {
    backgroundColor: theme.colors.primary + '10',
    borderRadius: theme.spacing.xxxl,
    padding: theme.spacing.xs * 2
  },
  flexShadowText: {
    backgroundColor: theme.colors.white,
    padding: theme.spacing.md,
    borderRadius: theme.border.jumbo,
    shadowColor: theme.colors.lightGrey,
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.3,
    shadowRadius: 10,
    elevation: 2,
  },
  buttonsContainer: {
    position: 'absolute',
    bottom: -20,
    left: 0,
    right: 0,
    flexDirection: 'row',
    justifyContent: 'space-between',
    ...(Platform.OS === 'web' && { justifyContent: 'center', gap: theme.spacing.xxxl }),
  },
  maxWidth: { 
    alignSelf: 'center',
    width: 500,
  },
  card: {
    flex: 1,
    // Whatever does not fit stays inside the card: stacked cards used to
    // poke their job titles out below it and overlap each other. Web only:
    // on iPhone, clipping would also cut the shadow.
    ...(Platform.OS === 'web' ? { overflow: 'hidden' as const } : {}),
    backgroundColor: theme.colors.white,
    padding: theme.spacing.md,
    margin: theme.spacing.sm,
    borderRadius: theme.iconSize.jumbo,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 6,
    elevation: 3,
    gap: theme.spacing.sm,
  },
})

export const getMergeContactsStyles = (theme: Theme) =>
  StyleSheet.create({
    containerCard: {
      backgroundColor: theme.colors.white,
      gap: theme.spacing.xxxl,
      alignItems: 'center',
      flex: 1,
      flexDirection: 'row',
      justifyContent: 'center',
    },
    profileCardContainer: {
      flex: 1,
      width: '100%', // Take full width, max-width calculated dynamically
      height: '100%',
      borderRadius: theme.iconSize.jumbo,
    },
    card: {
      backgroundColor: theme.colors.white,
      padding: theme.spacing.md,
      marginBottom: theme.spacing.sm,
      borderRadius: theme.iconSize.jumbo,
      shadowColor: "#000",
      shadowOffset: { width: 0, height: 2 },
      shadowOpacity: 0.1,
      shadowRadius: 6,
      elevation: 3,
      gap: theme.spacing.sm,
    },
    searchContainerNonMobile: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: theme.spacing.lg,
    },
})

export const getImportContactsStyles = (theme: Theme) => StyleSheet.create({
  content: {
    flex: 1,
    paddingTop: theme.spacing.md
  },
  cardContainer: {
    borderRadius: theme.fontSize.medium,
    borderWidth: 1,
    borderColor: theme.colors.primary,
    padding: theme.spacing.xxxl * 2,
    gap: theme.spacing.md,
    alignItems: 'center'
  },
  container: {
    flex: 1,
    marginVertical: theme.spacing.xxxl
  },
  card: {
    alignSelf: 'flex-start',
    backgroundColor: theme.colors.white,
    padding: theme.spacing.sm,
    marginTop: theme.spacing.sm,
    marginBottom: theme.spacing.xxxl,
    borderRadius: theme.spacing.lg,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 6,
    elevation: 3,
    gap: theme.spacing.xs,
  },
  fixedWidth: {
    width: 300
  },
  input: {
    paddingVertical: theme.spacing.md
  },
  action: {
    backgroundColor: theme.colors.primary,
    borderRadius: 25,
    paddingVertical: 16,
    margin: theme.spacing.md,
    marginBottom: theme.spacing.lg,
    alignItems: 'center',
  },
  contactItem: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: theme.spacing.md,
    height: ITEM_HEIGHT,
  },
  leftSection: {
    position: 'relative',
    marginRight: theme.spacing.md,
  },
  avatar: {
    width: AVATAR_SIZE,
    height: AVATAR_SIZE,
    borderRadius: AVATAR_SIZE / 2,
    backgroundColor: theme.colors.background,
  },
  middleSection: {
    flex: 1,
    justifyContent: 'center',
  },
  hashtags: {
    marginTop: theme.spacing.xs / 2,
  },
  rightSection: {
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: theme.spacing.md,
  },
  emptyContainer: {
    marginTop: theme.spacing.xxxl,
    alignItems: 'center',
    gap: theme.spacing.md
  }
})